<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index:1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="mb-4">
        <h3>Registrar Salida Manual de Inventario (Restaurante)</h3>
      </div>

      <!-- Formulario -->
      <div class="row g-4">
        <!-- Origen -->
        <div class="col-md-3">
          <label class="form-label">Origen</label>
          <select class="form-select" v-model.number="form.Origen" @change="cargarProductos">
            <option disabled value="">Seleccione origen</option>
            <option :value="0">Cocina</option>
            <option :value="1">Barra</option>
            <option :value="2">Limpieza</option>
            <option :value="3">Mobiliario</option>
            <option :value="4">General</option>
          </select>
        </div>

        <!-- Producto -->
        <div class="col-md-5">
          <label class="form-label">Producto</label>
          <input v-model="busquedaProducto" type="text" class="form-control mb-1" placeholder="Buscar producto..." :disabled="!form.Origen && form.Origen !== 0" />
          <select class="form-select" v-model="form.ProductoSeleccionado" @change="refrescarStock" :disabled="!form.Origen && form.Origen !== 0">
            <option value="" disabled>Seleccione un producto</option>
            <option
              v-for="p in productosFiltrados"
              :key="p.clave"
              :value="p.clave"
            >
              {{ p.NombreProducto }}
            </option>
          </select>
        </div>

        <!-- Stock -->
        <div class="col-md-2">
          <label class="form-label">Stock actual</label>
          <input type="text" class="form-control" :value="stockActual" disabled />
        </div>

        <!-- Cantidad -->
        <div class="col-md-2">
          <label class="form-label">Cantidad</label>
          <input v-model.number="form.Cantidad" type="number" min="0.01" step="0.01" class="form-control" />
        </div>

        <!-- Motivo -->
        <div class="col-md-12">
          <label class="form-label">Motivo</label>
          <input v-model="form.Motivo" type="text" class="form-control" placeholder="Opcional" maxlength="2500" />
        </div>
      </div>

      <div class="text-end mt-3">
        <button class="btn btn-primary" @click="guardarSalida">Registrar Salida</button>
      </div>

      <!-- Historial -->
      <div class="table-responsive mt-5">
        <h5>Historial de Salidas</h5>
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Fecha</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Origen</th>
              <th>Motivo</th>
              <th>Empleado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="salidas.length === 0">
              <td colspan="6">No hay salidas registradas.</td>
            </tr>
            <tr v-for="s in salidas" :key="s.IdSalidasInventariosRestaurantes">
              <td>{{ s.FechaSalida }}</td>
              <td>
                <!-- Muestra el nombre del producto según la relación que venga -->
                {{ s.producto?.NombreProducto || s.productoLimpieza?.NombreProducto || s.productoMobiliario?.NombreProducto || 'N/D' }}
              </td>
              <td>{{ s.Cantidad }}</td>
              <td>{{ origenTexto(s.Origen) }}</td>
              <td>{{ s.Motivo }}</td>
              <td>
                <!-- Intenta distintos esquemas de nombre -->
                <span v-if="s.empleado">
                  {{ s.empleado.Nombres || s.empleado.Nombre || '' }}
                  {{ s.empleado.Apellidos || s.empleado.Apellido || '' }}
                </span>
                <span v-else>N/D</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";
import store from "@/store";

export default {
  name: "SalidasInventariosRestaurante",
  data() {
    return {
      productos: [], // [{ clave, NombreProducto, StockActual, PrecioCosto }]
      salidas: [],
      busquedaProducto: "",
      stockActual: 0,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      form: {
        Origen: "",
        ProductoSeleccionado: "",
        Cantidad: null,
        Motivo: ""
      }
    };
  },
  computed: {
    empleadoId() {
      return store.getters.getUser?.IdEmpleado || null;
    },
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
    productosFiltrados() {
      const q = this.busquedaProducto.trim().toLowerCase();
      if (!q) return this.productos;
      return this.productos.filter(p => (p.NombreProducto || "").toLowerCase().includes(q));
    }
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    origenTexto(o) {
      // Soporta tanto número como texto por si el backend devuelve texto
      const map = { 0: "Cocina", 1: "Barra", 2: "Limpieza", 3: "Mobiliario", 4: "General" };
      if (typeof o === "number") return map[o] ?? "Desconocido";
      // si viene texto:
      const upper = String(o || "").toUpperCase();
      const inv = { COCINA: "Cocina", BARRA: "Barra", LIMPIEZA: "Limpieza", MOBILIARIO: "Mobiliario", GENERAL: "General" };
      return inv[upper] ?? "Desconocido";
    },

    async obtenerSalidas() {
      try {
        // index del resource -> últimos 150 (controlador ya limita con take(150))
        const { data } = await axios.get(`${API_URL}/salidas-inventarios-restaurante`);
        this.salidas = data;
      } catch (e) {
        console.error(e);
      }
    },

    async cargarProductos() {
      this.productos = [];
      this.form.ProductoSeleccionado = "";
      this.busquedaProducto = "";
      this.stockActual = 0;

      if (this.form.Origen === "" || this.form.Origen === null || this.form.Origen === undefined) return;

      try {
        let url = "";
        // 0 cocina, 1 barra, 2 limpieza, 3 mobiliario, 4 general
        switch (this.form.Origen) {
          case 0: url = `${API_URL}/inventario-cocina`; break;
          case 1: url = `${API_URL}/inventario-barra`; break;
          case 2: url = `${API_URL}/inv-limpieza`; break;
          case 3: url = `${API_URL}/inv-mobiliario`; break;
          case 4: url = `${API_URL}/inventario-general-restaurante`; break;
        }

        const { data } = await axios.get(url);

        // Aplanar en un formato unificado:
        // - Cocina/Barra: [{ StockActual, producto:{ IdProductoRestaurante, NombreProducto, PrecioCosto }}]
        // - Limpieza:     [{ IdProductoLimpieza, NombreProducto, StockActual, PrecioCosto }]
        // - Mobiliario:   [{ IdProductoMobiliario, NombreProducto, StockActual, PrecioCosto }]
        // - General:      [{ IdProductoRestaurante, NombreProducto, StockActual, PrecioCosto }]
        this.productos = (data || []).map((it) => {
          if (this.form.Origen === 0 || this.form.Origen === 1) {
            // cocina/barra
            return {
              clave: it.producto?.IdProductoRestaurante,
              NombreProducto: it.producto?.NombreProducto || "",
              StockActual: Number(it.StockActual) || 0,
              PrecioCosto: Number(it.producto?.PrecioCosto) || 0
            };
          } else if (this.form.Origen === 2) {
            // limpieza
            return {
              clave: it.IdProductoLimpieza,
              NombreProducto: it.NombreProducto || "",
              StockActual: Number(it.StockActual) || 0,
              PrecioCosto: Number(it.PrecioCosto) || 0
            };
          } else if (this.form.Origen === 3) {
            // mobiliario
            return {
              clave: it.IdProductoMobiliario,
              NombreProducto: it.NombreProducto || "",
              StockActual: Number(it.StockActual) || 0,
              PrecioCosto: Number(it.PrecioCosto) || 0
            };
          } else {
            // general
            return {
              clave: it.IdProductoRestaurante,
              NombreProducto: it.NombreProducto || "",
              StockActual: Number(it.StockActual) || 0,
              PrecioCosto: Number(it.PrecioCosto) || 0
            };
          }
        });
      } catch (e) {
        console.error(e);
        this.mostrarAlerta("No se pudieron cargar los productos del origen seleccionado.", "danger");
      }
    },

    refrescarStock() {
      const p = this.productos.find(x => x.clave === this.form.ProductoSeleccionado);
      this.stockActual = p ? p.StockActual : 0;
    },

    validar() {
      if (this.form.Origen === "" || this.form.Origen === null || this.form.Origen === undefined) return "Selecciona el origen.";
      if (!this.form.ProductoSeleccionado) return "Selecciona un producto.";
      if (!this.form.Cantidad || this.form.Cantidad <= 0) return "Ingresa una cantidad válida.";
      if (this.form.Cantidad > this.stockActual) return "La cantidad supera el stock actual.";
      return null;
    },

    async guardarSalida() {
      const err = this.validar();
      if (err) {
        this.mostrarAlerta(err, "danger");
        return;
      }

      try {
        // Construir payload según el origen
        const base = {
          Origen: this.form.Origen,
          Cantidad: this.form.Cantidad,
          Motivo: this.form.Motivo,
          IdEmpleado: this.empleadoId
        };

        if (this.form.Origen === 0 || this.form.Origen === 1 || this.form.Origen === 4) {
          base.IdProductoRestaurante = this.form.ProductoSeleccionado;
        } else if (this.form.Origen === 2) {
          base.IdProductoLimpieza = this.form.ProductoSeleccionado;
        } else if (this.form.Origen === 3) {
          base.IdProductoMobiliario = this.form.ProductoSeleccionado;
        }

        await axios.post(`${API_URL}/salidas-inventarios-restaurante`, base);

        this.mostrarAlerta("Salida registrada", "success");
        // Reset mínimos
        const origenTmp = this.form.Origen; // conserva para recargar productos
        this.form = { Origen: origenTmp, ProductoSeleccionado: "", Cantidad: null, Motivo: "" };
        // refrescar
        await this.cargarProductos();
        this.refrescarStock();
        this.obtenerSalidas();
      } catch (e) {
        console.error(e);
        const msg = e.response?.data?.message || "Error al registrar salida.";
        this.mostrarAlerta(msg, "danger");
      }
    }
  },
  mounted() {
    this.obtenerSalidas();
  }
};
</script>

<style scoped>
/* opcional: estilos del modal si los usas más adelante */
</style>
